export function calculateCommodityTotalValue(val: any): number {
  const commodities = val;
  if (!Array.isArray(commodities) || !commodities.length) {
    return 0;
  }

  return commodities.reduce((sum: number, c: any) => {
    const value = Number(c?.totalValue ?? 0);
    return sum + (isNaN(value) ? 0 : value);
  }, 0);
}
